import { keyframes, css } from 'styled-components'

const rightRollIn = keyframes`
  from {
    transform: rotate(20deg) translateX(5%) translateY(5%);
  }

  to {
    transform: rotate(0)  translateX(0) translateY(0);
  }
`

const animation = css`
  transform-origin: 50%;
  animation: ${rightRollIn} 1s cubic-bezier(0.87, 0, 0.13, 1); /* easeInOutExpo */
`

export default animation
